export default __webpack_public_path__ + "static/media/lifecycle.a418b9aa.png";